import React from "react";
import { Pressable } from "react-native";
import { BRAND_COLORS } from "@/lib/brandColors";
import { DASHBOARD_TOOLBAR_CONTROL_HEIGHT } from "@/lib/dashboardToolbarUi";

type DashboardOutlinedIconButtonProps = {
  onPress: () => void;
  active?: boolean;
  children: React.ReactNode;
  accessibilityLabel: string;
};

export function DashboardOutlinedIconButton({
  onPress,
  active = false,
  children,
  accessibilityLabel,
}: DashboardOutlinedIconButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      style={({ pressed }) => ({
        width: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
        height: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
        borderRadius: DASHBOARD_TOOLBAR_CONTROL_HEIGHT / 2,
        backgroundColor: active ? "#E5DCD3" : "white",
        borderWidth: 1,
        borderColor: BRAND_COLORS.border,
        alignItems: "center",
        justifyContent: "center",
        opacity: pressed ? 0.88 : 1,
      })}
    >
      {children}
    </Pressable>
  );
}
